import DisbursementRoute from "@outlets/dashboard/DisbursementRoute";
import CronogramaSuprimentos from "@outlets/dashboard/CronogramaSuprimentos";
import Curve from "@outlets/dashboard/Curve";
import ExtraValues from "@outlets/dashboard/ExtraValues";
import DashLessons from "@outlets/dashboard/Lessons";
import OrdersAndContracts from "@outlets/dashboard/OrdersAndContracts";
import Projection from "@outlets/dashboard/Projection";
import ItemsTimeline from "@outlets/dashboard/Timeline";
import Value from "@outlets/dashboard/Value";
import { element } from "prop-types";
import { isAmpliDisbursementPolicy } from "@components/dashboard/financialProjection/cashFlowPlanning";

export const options = {
  mainCards: [
    { label: 'Data de Início', value: 'startDate', tooltip: 'Data da primeira tarefa executada de acordo com o cronograma' },
    { label: 'Data de Término', value: 'endDate', tooltip: 'Última data prevista de acordo com o cronograma' },
    { label: 'Indexador', value: 'indexer', tooltip: 'Valor do indexador (CUB) de referência da obra para o mês vigente' },
    { label: 'Área', value: 'area', tooltip: 'Metragem total da obra de acordo com o projeto arquitetônico' }
  ],
  dashboard: {
    cards: {
      graph: [
        { label: 'Orçado Indexado/ Tendência', value: 'indexTrend', tooltip: 'Valor do Orçamento Indexado dividido pelo valor da Tendência da obra' },
        { label: 'IDC', value: 'idc', tooltip: 'Índice de Desempenho de Custo, calculado a partir da divisão do valor total Agregado (medido) pelo valor total Pago até a data da atualização dos dados' },
        { label: 'Pagamentos apropriados', value: 'apropriated', tooltip: 'Percentual do valor pago já vinculado aos itens do orçamento' },
        { label: 'IDP', value: 'idp', tooltip: 'Índice de Desempenho de Prazo, calculado a partir da divisão do percentual medido acumulado pelo percentual acumulado da linha Base até a data da medição' },
        { label: 'Pagamentos apropriados / Comprometido', value: 'apr_compr', tooltip: 'Valor dos pagamentos apropriados dividido pelo valor comprometido' }

      ],
      lower: [
        { label: 'Orçamento Base', value: 'budgetValue', tooltip: 'Valor agregado previsto pela linha Base do cronograma' },
        // { label: 'Orçamento Indexado - Baseado no Saldo Indexado', value: 'budgetIndexed', tooltip: 'Correção do orçamento base no tempo utilizando a variação do cub e cálculos baseados na execução física do serviço e saldo disponível.' },
        { label: 'Orçamento Indexado', value: 'budgetIndexedGlobal', tooltip: 'Correção do orçamento base no tempo, considerando o orçamento base e a multiplicação do orçamento pela variação do indexador no período entre o mês base e a última medição.' },
        { label: 'Total Comprometido', value: 'committedTotal', tooltip: 'Valor total comprometido para a obra somando todos os itens pagos e a pagar' },
        { label: 'Verba disponível', value: 'available', tooltip: 'Resultado da subtração do Total Comprometido do Orçamento Base' },
        // { label: 'Verba disponível - Indexado', value: 'availableIndexed', tooltip: 'Resultado da subtração do Total Comprometido do Orçamento Indexado Baseado no Saldo Indexado' },
        { label: 'Verba disponível - Indexado', value: 'availableIndexedGlobal', tooltip: 'Resultado da subtração do Total Comprometido do Orçamento Indexado Global' },
        { label: 'Base Acumulado ', value: 'baseAccumulated', tooltip: 'Valor base acumulado até o final do mês da medição' },
        { label: 'Previsto Acumulado ', value: 'predictedAccumulated', tooltip: 'Valor previsto acumulado até o final do mês da medição' },
        { label: 'Agregado Acumulado', value: 'aggregatedAccumulated', tooltip: 'Valor percentual agregado acumulado até a data da medição' },
        { label: 'Diferença Previsto x Agregado', value: 'difPrevAggr', tooltip: 'Diferença percentual entre a linha de Previsto Acumulada e o Valor Agregado acumulado na data da última medição' },
        { label: 'Diferença Base x Agregado', value: 'difBaseAggr', tooltip: 'Diferença percentual entre a linha de Base Acumulado e o Valor Agregado acumulado na data da última medição' },
        { label: 'Tendência', value: 'trend', tooltip: 'Estimativa de custo para a obra de acordo com o padrão de custo realizado.' },
        { label: 'CUB por metro quadrado', value: 'cubArea', tooltip: 'Valor de CUB dividido pela Área Construída (M²)' },
        { label: 'Orçamento por metro quadrado', value: 'budgetArea', tooltip: 'Valor de Orçamento dividido pela Área Construída (M²)' },
        { label: 'Orçamento Indexado por metro quadrado', value: 'budgetIndexedArea', tooltip: 'Valor de Orçamento Indexado dividido pela Área Construída (M²)' },
        { label: 'Estouros / Economias', value: 'extraValues', tooltip: 'Estouros e economias registrados na obra' },
        { label: 'Origem do custo', value: 'costOriginSplit', tooltip: 'Divisão do custo da obra no Sienge (pago + a pagar) entre via suprimentos (pedidos/contratos) e via financeiro (lançado direto)' },
        { label: 'Valores a contratar', value: 'toContract', tooltip: 'Valores que ainda precisam ser contratados para a obra' },
        { label: 'Desvio Tendência', value: 'trendDeviation', tooltip: '(Orçamento base) - (Tendência)' },
        // { label: 'Desvio (%)', value: 'deviationPercentage' },
        { label: 'Tendência por metro quadrado', value: 'trendPerArea' },
        { label: 'Variação CUB', value: 'cubVariation' },

      ]
    },
    graphs: {
      flux: [
        { label: 'Previsto', value: 'scheduled', tooltip: 'Curva de valor previsto acumulado' },
        { label: 'Base', value: 'base', tooltip: 'Curva de valor da linha de base acumulado' },
        { label: 'Medido', value: 'measured', tooltip: 'Valor agregado medido acumulado (Prevision quando disponível, senão Sienge)' },
        { label: 'Desembolso Acumulado', value: 'accumulatedDisbursement', tooltip: 'Tooltip for Desembolso Acumulado' },
        { label: 'Pago Acumulado', value: 'accumulatedPaid', tooltip: 'Tooltip for Pago Acumulado' }
      ],
      financial: [
        { label: 'Agregado', value: 'measured', tooltip: 'Tooltip for Agregado' },
        { label: 'Previsto', value: 'scheduled', tooltip: 'Tooltip for Previsto' },
        { label: 'Base', value: 'base', tooltip: 'Tooltip for Base' }
      ]
    }
  },
  value: {
    cards: [
      { label: 'Previsto', value: 'predicted', tooltip: 'Valor agregado previsto pelo cronograma atual da obra' },
      { label: 'Medido', value: 'measured', tooltip: false },
      { label: 'Pago', value: 'paid', tooltip: false }
    ]
  },
  projection: {
    graphs: {
      projection: [
        { label: 'Desembolso', value: 'disbursement', tooltip: 'Tooltip for Desembolso' },
        { label: 'Desembolso (Ampli)', value: 'ampliDisbursement', tooltip: 'Previsto redistribuído no tempo pelas regras de desembolso cadastradas na Ampli' },
        { label: 'Pago', value: 'paid', tooltip: 'Tooltip for Pago' },
        { label: 'A Pagar', value: 'toPay', tooltip: 'Tooltip for A Pagar' }],
      advancements: [{ label: 'Físico Financeiro', value: 'physicals', tooltip: 'Tooltip for Físico Financeiro' },
        { label: 'Desembolso', value: 'disbursement', tooltip: 'Tooltip for Desembolso' },
        { label: 'Desembolso (Ampli)', value: 'ampliDisbursement', tooltip: 'Previsto redistribuído no tempo pelas regras de desembolso cadastradas na Ampli' },
        { label: 'Desembolso com ajustes', value: 'disbWithAdvance', tooltip: 'Desembolso com os ajustes de mês aplicados' },
        { label: 'Pago', value: 'paid', tooltip: 'Tooltip for Pago' },
        { label: 'A Pagar', value: 'toPay', tooltip: 'Tooltip for A Pagar' },
        { label: 'Movido para', value: 'takenTo', tooltip: 'Valor movido para este mês' },
        { label: 'Movido de', value: 'takenFrom', tooltip: 'Valor movido deste mês para outro' },
        { label: 'Medido', value: 'measuredMonthly', tooltip: 'Valor agregado medido no mês (Prevision quando disponível, senão Sienge)' }],
      balance: [{ label: 'Comprometido', value: 'commited', tooltip: 'Tooltip for Comprometido' }
      ]
    }
  },
  offcanvas: {
    cards: [
      { label: 'Comprometido', value: 'commited', tooltip: 'Tooltip for Comprometido' },
      { label: 'Pago (R$)', value: 'paid', tooltip: 'Tooltip for Pago (R$)' },
      { label: 'A Pagar (R$)', value: 'toPay', tooltip: 'Tooltip for A Pagar (R$)' },
      { label: 'Orçado', value: 'budget', tooltip: 'Tooltip for Orçado' },
      { label: 'Medido', value: 'measured', tooltip: 'Tooltip for Medido' },
      { label: 'Tendência', value: 'trend', tooltip: 'Projeção de quanto o item vai custar no fim, calculada pela faixa de avanço configurada nas Configurações.' },
      { label: 'IDC', value: 'idc', tooltip: 'Tooltip for IDC' },
      { label: 'Estouro / Economia', value: 'extraValue', tooltip: 'Tooltip for Estouro / Economia' },
      { label: 'Comprometido + Estouros / Economias', value: 'extraCommited', tooltip: 'Tooltip for Comprometido + Estouros / Economias' },
      { label: 'Em estoque', value: 'stock', tooltip: 'Tooltip for Em estoque' },
      { label: 'Tendência com estoque', value: 'stockTrend', tooltip: 'Mesma projeção da Tendência, descontando do custo acumulado o material comprado e ainda não aplicado.' },
    ],
  }
};
export const columns = {
  value: [
    { label: 'Previsto', value: 'predicted' },
    { label: 'Medido', value: 'measured' }
  ],
  projection: [
    { label: 'Físico Financeiro', value: 'physical' },
    { label: 'Orçamento Indexado', value: 'indexedBudget' },
    { label: 'Desembolso', value: 'disbursement' },
    { label: 'Desembolso (Ampli)', value: 'ampliDisbursement' },
    { label: 'Medido', value: 'measured' },
    { label: 'Pago', value: 'paid' },
    { label: 'A Pagar', value: 'toPay' },
    { label: 'Comprometido (Pago + A Pagar)', value: 'paidToPay' },
    { label: 'Verba Disponível', value: 'availableBudget' },
    { label: 'Verba Disponível Indexada', value: 'availableBudgetIndexed' },
    { label: 'Verba Positiva', value: 'availablePos' },
    { label: 'Verba Negativa', value: 'availableNeg' },
    { label: 'Estouros / Economias', value: 'extraValues' }
  ]
}
export const graphColorLabels = {
  physical: "Físico Financeiro",
  paid: "Pago",
  toPay: "A Pagar",
  disbursement: "Desembolso",
  ampliDisbursement: "Desembolso (Ampli)",
  cashProjection: "Desembolso projetado",
  predicted: "Previsto",
  accumulatedDisbursement: "Desembolso Acumulado",
  accumulatedPaid: "Pago Acumulado",
  advancementTo: "Movido para",
  advancementFrom: "Movido de",
  commited: "Comprometido"
};

export const resolveDashboardPathPermission = ({ label, permission } = {}) => (
  permission || label
);

/**
 * O rótulo do menu depende da política de previsão de caixa da obra ativa: a mesma
 * rota é "Desembolso" no modo Ampli e "Ajustes de desembolso" no modo Sienge. A
 * PERMISSÃO não muda ("Adiantamentos"), senão todo usuário perderia o acesso.
 */
export const resolveDashboardPathLabel = (item, policy) => {
  if (
    resolveDashboardPathPermission(item) === "Adiantamentos"
    && isAmpliDisbursementPolicy(policy)
  ) {
    return "Desembolso";
  }
  return item?.label ?? "";
};

export const dashboardPaths = [{
  path: "valor-agregado",
  label: "Valor agregado",
  element: <Value />
}, {
  path: "projecao-financeira",
  label: "Projeção financeira",
  element: <Projection />
}, {
  path: "curva",
  label: "Curva ABC",
  element: <Curve />
}, {
  path: "adiantamentos",
  label: "Ajustes de desembolso",
  permission: "Adiantamentos",
  element: <DisbursementRoute />
}, {
  path: "valores",
  label: "Estouros / Economias",
  permission: "Valores não lançados",
  element: <ExtraValues />
}, {
  path: "titulos",
  label: "Títulos",
  element: <ItemsTimeline />
}, {
  path: "licoes",
  label: "Lições aprendidas",
  element: <DashLessons />
}, {
  path: "pedidoscontratos",
  label: "Pedidos e Contratos",
  element: <OrdersAndContracts />
}, {
  path: "cronograma-suprimentos",
  label: "Cronograma de Suprimentos",
  element: <CronogramaSuprimentos />
}
]
